import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from './AppShell';
import { refreshToLatest } from '../utils/refreshToLatest';
import './RefreshPage.css';

const RefreshPage: React.FC = () => {
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    // 立即清除标志，确保在刷新前完成
    try {
      localStorage.removeItem('sw_has_update_available');
    } catch (error) {
      console.warn('[RefreshPage] Failed to clear update flag:', error);
    }
    // 延迟一下，让用户看到反馈
    setTimeout(async () => {
      await refreshToLatest();
    }, 300);
  };

  const header = (
    <div className="refresh-header app-shell-header-content">
      <button
        onClick={() => navigate('/profile/settings')}
        className="back-button"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h1>刷新页面</h1>
    </div>
  );

  return (
    <AppShell header={header} footer={null}>
      <div className="refresh-container">
        <div className="refresh-content">
          <div className="refresh-form">
            <div className="refresh-info">
              <div className="refresh-item">
                <div className="refresh-item-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <polyline points="1 20 1 14 7 14"></polyline>
                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                  </svg>
                </div>
                <div className="refresh-item-content">
                  <div className="refresh-item-label">刷新说明</div>
                  <div className="refresh-item-value">
                    点击下方按钮刷新页面，获取最新版本的应用。刷新后，您将看到最新的功能和改进。
                  </div>
                </div>
              </div>
            </div>
            <div className="form-actions">
              <button
                className="save-button"
                onClick={handleRefresh}
                disabled={isRefreshing}
              >
                {isRefreshing ? (
                  <>
                    <svg className="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23 4 23 10 17 10"></polyline>
                      <polyline points="1 20 1 14 7 14"></polyline>
                      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                    </svg>
                    <span>正在刷新...</span>
                  </>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23 4 23 10 17 10"></polyline>
                      <polyline points="1 20 1 14 7 14"></polyline>
                      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                    </svg>
                    <span>刷新页面</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
};

export default RefreshPage;

